export const CONTEXT_MENU_TESTID = 'software-context-menu.ui.context-menu';
